/**
 * Contact Details Pattern
 * Toggle country accordion items open/closed on header click.
 */
$(document).ready(function () {
  $(document).on('click', '.pattern-contact-details .cd-accordion-header', function () {
    const $header  = $(this);
    const $item    = $header.closest('.cd-accordion-item');
    const $content = $item.find('.cd-accordion-content');
    const $icon    = $header.find('.cd-accordion-icon');
    const isActive = $item.hasClass('active');

    // Close all items in this accordion
    const $accordion = $item.closest('.cd-accordion');
    $accordion.find('.cd-accordion-item.active').each(function () {
      $(this).removeClass('active');
      $(this).find('.cd-accordion-header').attr('aria-expanded', 'false');
      $(this).find('.cd-accordion-icon').text('+');
      $(this).find('.cd-accordion-content').css('max-height', '0');
    });

    // Open clicked item if it was closed
    if (!isActive) {
      $item.addClass('active');
      $header.attr('aria-expanded', 'true');
      $icon.text('-');
      $content.css('max-height', $content[0].scrollHeight + 'px');
    }
  });
});
